/* eslint-disable */
export default {
  forward: 'Lähetä edelleen',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
